import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { retry } from 'rxjs/operators';
import { MunicipioSinEstudioAutomaticoEntry } from 'src/app/shared/entrys/municipio-sin-estudio-automatico.entry';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';

@Injectable({
  providedIn: 'root'
})
export class MunicipiosSinEstudioAutomaticoService {
  private API_URL;

  constructor(
    private http: HttpClient,
    enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  obtenerListadoMunicipiosSinEstudioAutomatico(filter, paginaActual, pageSize = 12) {
    return this.http
      .post<any>(
        `${this.API_URL}/MunicipiosSinEstudioAutomatico/Paginado?PageNumber=${paginaActual}&PageSize=${pageSize}`,
        filter
      )
      .pipe(retry(2));
  }

  Crear(municipioSinEstudioAutomatico: MunicipioSinEstudioAutomaticoEntry) {
    return this.http
      .post<any>(
        `${this.API_URL}/MunicipiosSinEstudioAutomatico/Crear`,
        municipioSinEstudioAutomatico
      )
      .pipe(retry(2));
  }

  eliminar(municipioSinEstudioAutomatico: MunicipioSinEstudioAutomaticoEntry) {
    return this.http
      .post<any>(
        `${this.API_URL}/MunicipiosSinEstudioAutomatico/Eliminar`,
        municipioSinEstudioAutomatico
      )
      .pipe(retry(2));
  }
}
